module.exports = __webpack_public_path__ + "static/media/shapes_27.3439cb2d.svg";